// extracted by mini-css-extract-plugin
export default {"dropdowns":"BattingByExitVelocity_dropdowns__kIINB"};